export const RlaTypes = {
  route: 'route',
  link: 'link',
  action: 'action',
} as const;

export type RlaTypesType = keyof typeof RlaTypes;

interface RlaBase {
  id?: number | string;
  label: string;
  icon?: string;
  disabled?: boolean;
  children?: RouteLinkAction[];
}

export interface RlaRoute extends RlaBase {
  type: 'route';
  route: any[] | string | null | undefined;
}

export interface RlaLink extends RlaBase {
  type: 'link';
  href: string;
  target?: '_blank' | '_self';
}

export interface RlaAction extends RlaBase {
  type: 'action';
  cb: (...args: any[]) => any;
}

export type RouteLinkAction = RlaRoute | RlaLink | RlaAction;

// type guards

export const RlaGuards = {
  isRoute: function isRlaRoute(rla: RouteLinkAction): rla is RlaRoute {
    return rla.type === RlaTypes.route;
  },
  isLink: function isRlaLink(rla: RouteLinkAction): rla is RlaLink {
    return rla.type === RlaTypes.link;
  },
  isAction: function isRlaAction(rla: RouteLinkAction): rla is RlaAction {
    return rla.type === RlaTypes.action;
  },
};
